{
  "de": {
    "form": {
      "actions": {
        "cancel": "Abbrechen",
        "clear": "Leeren",
        "closeFullPage": "Vollbildansicht schließen",
        "copyText": "Klicken, um den Text zu kopieren",
        "create_and_send_to_customer": "Erstellen und an den Kunden senden",
        "create_and_share": "Erstellen und mit dem Kunden teilen",
        "create_and_share_partners_only": "Erstellen und mit Partner(n) teilen",
        "create_and_share_with_partners": "Erstellen und mit Kunden und Partner(n) teilen",
        "next": "Weiter",
        "only_create": "Nur erstellen",
        "openFullPage": "In Vollbildansicht öffnen",
        "save": "Speichern",
        "saveChanges": "Änderungen speichern",
        "search": "Suche...",
        "send": "Senden",
        "send_and_create_another": "Senden und weitere erstellen",
        "send_to_customer": "An den Kunden senden",
        "share_with_customer": "Mit dem Kunden teilen",
        "submit": "Absenden",
        "submit_and_create_another": "Absenden und weitere erstellen"
      },
      "back": "Vorheriger Schritt",
      "labels": {
        "columns": "Spalten",
        "from": "Von",
        "no_results": "Keine Ergebnisse",
        "optional": "(optional)",
        "to": "Bis"
      },
      "notifications": {
        "textHasBeenCopied": "Text wurde kopiert"
      },
      "password": "Passwort",
      "shortcuts": {
        "save_mac": "⌘ + Enter zum Speichern",
        "save_windows": "Strg + Enter zum Speichern",
        "send_mac": "⌘ + Enter zum Senden",
        "send_windows": "Strg + Enter zum Senden"
      },
      "steps": "Schritt {count} von {total}",
      "writeEmployeeNameReject": "Schreiben Sie <i><b>{employeeName}</b></i>, um fortzufahren."
    }
  }
}
